var _g, _defs;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
import { forwardRef } from "react";
var SvgMenuWhite = function SvgMenuWhite(_ref, ref) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 512,
    height: 512,
    viewBox: "0 0 512 512",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_1018_26)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M490.667 276.89H21.3333C9.55729 276.89 0 267.333 0 255.557C0 243.781 9.55729 234.224 21.3333 234.224H490.667C502.443 234.224 512 243.781 512 255.557C512 267.333 502.443 276.89 490.667 276.89Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M490.667 113.333H21.3333C9.55729 113.333 0 103.776 0 91.9998C0 80.2238 9.55729 70.6665 21.3333 70.6665H490.667C502.443 70.6665 512 80.2238 512 91.9998C512 103.776 502.443 113.333 490.667 113.333Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M490.667 440.443H21.3333C9.55729 440.443 0 430.886 0 419.11C0 407.334 9.55729 397.776 21.3333 397.776H490.667C502.443 397.776 512 407.334 512 419.11C512 430.886 502.443 440.443 490.667 440.443Z",
    fill: "white"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_1018_26"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 512,
    height: 512,
    fill: "white"
  })))));
};
var ForwardRef = /*#__PURE__*/forwardRef(SvgMenuWhite);
export { ForwardRef as ReactComponent };
export default __webpack_public_path__ + "static/media/menu_white.77b0718f12e7cb2d209e3e6223091a6e.svg";